/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetFileByNamePathParameters } from 'api/actions/get-file-by-name/get-file-by-name-path-parameters';
import { GetFileByNameResponse } from 'api/actions/get-file-by-name/get-file-by-name-response';

type GetFileByNameQueryParameters = Record<string, any>;

/**
 * The path of the GetFileByName action.
 */
export const getFileByNameActionPath = new SweetPath<keyof GetFileByNamePathParameters>('/files/{publicId}/{name}', {
  path: '{param}',
});

/**
 * Creates a contextualized GetFileByName actions.
 */
export default function createGetFileByNameAction(axios: AxiosInstance) {
  return function getFileByNameAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetFileByNamePathParameters;
    query?: GetFileByNameQueryParameters;
  }) {
    const path = getFileByNameActionPath.insert(parameters);

    return axios.get<GetFileByNameResponse, GetFileByNameResponse>(path, { params: query, headers });
  };
}
